module.exports = __webpack_public_path__ + "img/score-7.1243d199.png";